import {
  ArtworkApprovalRequestType,
  ArtworkApprovalRequestTypes,
  ArtworkApprovalsState,
} from "./data.type";

const initialState: ArtworkApprovalsState = {
  collectionApprovalResultsIsLoading: false,
  collectionSearchResultsIsLoading: false,
  printingTechniqueApprovalResultsIsLoading: false,
  printingTechniqueSearchResultsIsLoading: false,
  collectionSearchResults: null,
  printingTechniqueSearchResults: null,
  collectionFilters: {
    hasFilterApplied: false,
    lastDays: -1,
    limit: 50,
    offset: 0,
    requestor: "",
    search: "",
    status: ["APPROVED", "CREATED", "SUBMITTED", "REJECTED"],
  },
  collectionSearchFilters: {
    collection: null,
    launch_date: "",
    licensed_property: null,
    licensor: null,
    limit: 50,
    offset: 0,
    requesting_market: { full_name: "", id: "", short_name: "" },
    search: "",
    year: "",
  },
  printingTechniqueFilters: {
    hasFilterApplied: false,
    lastDays: -1,
    limit: 50,
    offset: 0,
    requestor: "",
    search: "",
    status: ["APPROVED", "CREATED", "SUBMITTED", "REJECTED"],
  },
  printingTechniqueSearchFilters: {
    collection: null,
    color: null,
    name: "",
    code: "",
    // purchased_parts: "",
    // technical_file_comment: "",
    decoration_technique: null,
    molds: [],
    printingTechnique: null,
    limit: 50,
    offset: 0,
    requesting_market: { full_name: "", id: "", short_name: "" },
    search: ""
  },

  collectionResults: null,
  printingTechniqueResults: null
};

const reducer = (
  state: ArtworkApprovalsState,
  action: ArtworkApprovalRequestType,
): ArtworkApprovalsState => {
  if (action.type === ArtworkApprovalRequestTypes.SET_APPROVAL_STATE) {
    return { ...state, ...action.payload };
  }

  return { ...state, [action.type]: action.payload };
};

export const isStateEqualToInitialState = (
  state: ArtworkApprovalsState,
  key:
    | "collectionFilters"
    | "collectionSearchFilters"
    | "printingTechniqueFilters"
): boolean => {
  const cleanedUpdState = {
    ...state.collectionFilters,
    ...state.collectionSearchFilters,
    ...state.printingTechniqueFilters,
  };

  const initialFilters = {
    collectionFilters: {
      hasFilterApplied: false,
      lastDays: -1,
      limit: 50,
      offset: 0,
      requestor: "",
      search: "",
      status: ["APPROVED", "CREATED", "SUBMITTED", "REJECTED"],
    },
    collectionSearchFilters: {
      collection: null,
      printingTechnique: null,
      launch_date: "",
      licensed_property: null,
      licensor: null,
      limit: 0,
      offset: 0,
      requesting_market: { full_name: "", id: "", short_name: "" },
      search: "",
      year: "",
    },
    printingTechniqueFilters: {
      hasFilterApplied: false,
      lastDays: -1,
      limit: 50,
      offset: 0,
      requestor: "",
      search: "",
      status: ["APPROVED", "CREATED", "SUBMITTED", "REJECTED"],
    },
  };

  return JSON.stringify(state[key]) === JSON.stringify(initialFilters[key]);
};

export const ArtworkApprovalsReducer = { initialState, reducer };
